<template>
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">
		<section class="error-section py-40" v-if="!product && !loading">
			<div class="container-fluid">
				<div class="error-wrapper text-center py-40 bg-white br-10">
					<h1 class="mb-32">404</h1>
					<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
					<p class="light-gray mb-32">Товар не найден.<br/>Возможно он был удален либо никогда не существовал.</p>
					<router-link :to="{path: '/catalog'}" class="cus-btn">В каталог товаров</router-link>
				</div>
			</div>
		</section>
		
		<div v-else>
			<section class="blog-detail-section bg-lightest-gray pt-40">
				<div class="container-fluid">
					<div class="row row-gap-4">
						<div class="col-md-8 offset-md-2">
							<div class="top-bar mb-16">
								<router-link :to="{path: '/catalog'}" class="cus-btn-arrow">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<path d="M9.48438 17.25C9.48438 15 7.38438 12 4.98438 12M4.98438 12C6.35938 12 9.48437 11.25 9.48438 6.75M4.98438 12H19.2344" stroke="#141516" stroke-width="1.5"></path>
									</svg>
									Назад в каталог товаров
								</router-link>
								<div v-if="authModel.isAdmin()">
									<router-link :to="{path: '/admin/products/'+product?.id}" class="btn btn-sm btn-primary me-2">
										<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" /></svg>
									</router-link>
									<button type="button" class="btn btn-sm btn-danger" @click="onDelete">
										<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" /></svg>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			
			<!-- Shop Detail Start -->
			<section class="shop-detail pb-40">
				<div class="container-fluid">
					<div class="detail-wrapper">
						<div class="row row-gap-3">
							<div class="col-xl-6">
								<div class="product-text-container bg-white br-20">
									<carousel id="gallery" v-bind="galleryConfig" v-model="currentSlide">
										<slide v-for="image in (product?.images||[])" :key="image.id">
											<img :src="'/'+image.path" alt="Gallery Image" class="gallery-image" />
										</slide>
									</carousel>
									<carousel id="thumbnails" v-bind="thumbnailsConfig" v-model="currentSlide">
										<slide v-for="image in (product?.images||[])" :key="image.id">
											<template #default="{ currentIndex, isActive }">
												<div
													:class="['thumbnail', { 'is-active': isActive }]"
													@click="slideTo(currentIndex)"
												>
													<img :src="'/'+image.path" alt="Thumbnail Image" class="thumbnail-image" />
												</div>
											</template>
										</slide>
										<template #addons>
											<navigation />
										</template>
									</carousel>
								</div>
								<!--
								<div class="product-image-container container-2 bg-white">
									<div class="product-slider-asnav asnav-2">
										<div class="nav-image">
											<img src="/assets/media/products/nav-image-1.png" alt="">
										</div>
										<div class="nav-image">
											<img src="/assets/media/products/nav-image-2.png" alt="">
										</div>
										<div class="nav-image">
											<img src="/assets/media/products/nav-image-3.png" alt="">
										</div>
										<div class="nav-image">
											<img src="/assets/media/products/nav-image-4.png" alt="">
										</div>
									</div>
									<div class="product-slider slider-2">
										<div class="detail-image detail-2">
											<img src="/assets/media/products/large-image-1.png" alt="">
										</div>
										<div class="detail-image detail-2">
											<img src="/assets/media/products/large-image-2.png" alt="">
										</div>
										<div class="detail-image detail-2">
											<img src="/assets/media/products/large-image-3.png" alt="">
										</div>
										<div class="detail-image detail-2">
											<img src="/assets/media/products/large-image-4.png" alt="">
										</div>
									</div>
								</div>
								-->
							</div>
							<div class="col-xl-6">
								<div class="product-text-container bg-white br-20">
									<h3 class="fw-700 mb-16">{{product?.name}}</h3>
									<div class="d-flex align-items-center gap-16 mb-24">
										<p class="light-gray text-decoration-line-through" v-if="product?.oldPrice">{{number_format(product?.oldPrice)}} тг</p>
										<h5>{{number_format(product?.price)}} тг</h5>
										<!--<span class="label white">-12%</span>-->
									</div>
									<div class="hr-line mb-24"></div>
									<div class="function-bar mb-20">
										<div class="quantity quantity-wrap">
											<div class="input-area quantity-wrap" v-if="appModel.hasProductInBasket(product?.id)">
												<input class="decrement" type="button" value="-" @click="appModel.getProductFromBasket(product?.id).count--">
												<input type="number" @wheel="$event.target.blur()" v-model.number="appModel.getProductFromBasket(product?.id).count" class="number noscroll">
												<input class="increment" type="button" value="+" @click="appModel.getProductFromBasket(product?.id).count++">
											</div>
											<div class="input-area quantity-wrap" v-else>
												<input class="decrement" type="button" value="-" @click="forBasketCount--">
												<input type="number" @wheel="$event.target.blur()" v-model.number="forBasketCount" class="number noscroll">
												<input class="increment" type="button" value="+" @click="forBasketCount++">
											</div>
										</div>
										<div class="cart-btn w-100">
											<a href="#" @click.prevent="toggleProductBasket(product)" class="w-100" :class="{'cus-btn-2': !appModel.hasProductInBasket(product?.id), 'cus-btn-3': appModel.hasProductInBasket(product?.id)}">
												<span v-if="!appModel.hasProductInBasket(product?.id)">В КОРЗИНУ</span>
												<span v-else>УБРАТЬ ИЗ КОРЗИНЫ</span>
											</a>
										</div>
										<div class="side-icons">
											<ul class="list-unstyled m-0">
												<li>
													<a href="#" @click.prevent="appModel.toggleProductWishlist(product)" class="btn">
														<svg v-if="!appModel.hasProductInWishlist(product?.id)" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" /></svg>
														<svg v-else width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" /></svg>
													</a>
												</li>
											</ul>
										</div>
									</div>
									<a href="#" @click.prevent="checkoutProduct" class="cus-btn-3 w-100 mb-24">КУПИТЬ СЕЙЧАС</a>
									<div class="hr-line mb-24"></div>
									<div class="d-flex align-items-center gap-16">
										<h6>Категория:</h6>
										<p class="light-gray">{{product?.category_name}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- Shop Detail End -->
		
			<!-- Product Description Start -->
			<section class="product-description pb-40">
				<div class="container-fluid">
					<div class="row">
						<div class="description-wrapper bg-white br-20">
							<nav class="mb-32">
								<div class="nav nav-tabs" id="nav-tab" role="tablist">
									<button class="nav-link active" id="nav-desc-tab" data-bs-toggle="tab" data-bs-target="#nav-desc" type="button" role="tab" aria-controls="nav-desc" aria-selected="true">Описание</button>
								</div>
							</nav>
							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane fade active show" id="nav-desc" role="tabpanel" aria-labelledby="nav-desc-tab">
									<p class="light-gray" v-html="product?.description"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- Product Description End -->
		</div>
	
		<benefits :footer-class="['bg-white']" />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
.carousel {
	--vc-nav-background: rgba(255, 255, 255, 0.7);
	--vc-nav-border-radius: 100%;
}

#gallery {
	img {
		height: 100%;
		width: 100%;
		object-fit: contain;
	}
}

#thumbnails {
	margin-top: 1rem;
	
	.thumbnail {
		height: 100%;
		width: 100%;
		cursor: pointer;
		opacity: 0.6;
		transition: opacity 0.3s ease-in-out;
		
		&.is-active,
		&:hover {
			opacity: 1;
		}
		
		img {
			height: 100%;
			width: 100%;
			object-fit: contain;
		}
	}
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import 'vue3-carousel/carousel.css';
import { Carousel, Slide, Navigation } from 'vue3-carousel';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		loading: true,
		
		product: null,
		
		forBasketCount: 1,
		
		currentSlide: 0,
		galleryConfig: {
			itemsToShow: 1,
			wrapAround: true,
			touchDrag: false,
			height: 580,
		},
		thumbnailsConfig: {
			itemsToShow: 6,
			wrapAround: false,
			touchDrag: false,
			height: 80,
			gap: 10,
		},
	}),
	watch: {
		forBasketCount: {
			handler(newVal) {
				if (newVal <= 0 || isNaN(newVal)) {
					this.forBasketCount = 1;
				}
			},
		},
		'appModel.basketProducts': {
			handler(newVal) {
				newVal.forEach((product) => {
					if (product.count <= 0 || isNaN(product.count)) {
						product.count = 1;
					}
				});
				localStorage.setItem('basketProducts', JSON.stringify(this.appModel.basketProducts));
			},
			deep: true,
		},
	},
	methods: {
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		slideTo(nextSlide) {
			this.currentSlide = nextSlide;
		},
		
		toggleProductBasket(product){
			if (this.appModel.hasProductInBasket(product.id)) {
				this.forBasketCount = this.appModel.getProductFromBasket(product.id).count||1;
			}
			this.appModel.toggleProductBasket(product, this.forBasketCount);
		},
		checkoutProduct(){
			this.appModel.checkoutProducts = [{
				...this.product,
				count: this.appModel.hasProductInBasket(this.$route.params.id) ? this.appModel.getProductFromBasket(this.$route.params.id).count||1 : this.forBasketCount,
			}];
			this.$router.push({path: '/checkout'});
		},
		
		async loadProduct(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetProduct(this.$route.params.id);
			if(ret.success){
				this.product = ret.item;
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данный товар?')){
				const ret = await this.appModel.doDeleteProduct(this.$route.params.id);
				if(ret.success){
					this.$router.push('/catalog');
				} else {
					alert(ret.error);
				}
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.loadProduct();
	},
	beforeRouteUpdate(to, from, next){
		if (from.params.id !== to.params.id) {
			this.product = null;
			this.loadProduct();
		}
		
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
		
		Carousel,
		Slide,
		Navigation,
	},
};
</script>